import { Drawer, List, Tag, Button } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useCallback } from "react";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import axios from "axios";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import { fetchWorkflowTipoTarefa, selectWorkflowTipoTarefaId } from "../../store/workflow";
import { useSelector } from "react-redux";

export default function TiposTarefasDrawer({ visible, onClose, onAfterClose, workflowId }) {
  const { t } = useTranslation();
  const [tipos, setTipos] = useState([]);
  const dispatch = useDispatchWithResult();
  const selectedTipoTarefaId = useSelector((state) => state.workflow?.selectedTipoTarefaId);

  const fetchTipos = useCallback(() => {
    if (!workflowId) return;
    unwrapAxiosPromise(axios.get(`/workflows/${workflowId}/tipos-tarefas`, { params: { emUso: true } })).then((data) => setTipos(data));
  }, [workflowId]);

  useEffect(() => {
    fetchTipos();
  }, [fetchTipos]);

  useEffect(() => {
    if (selectedTipoTarefaId === null) {
      fetchTipos();
    }
  }, [selectedTipoTarefaId, fetchTipos]);

  const handleAlterarClick = useCallback(
    (id) => {
      unwrapAxiosPromise(dispatch(fetchWorkflowTipoTarefa({ workflowId, id })));
      dispatch(selectWorkflowTipoTarefaId(id));
    },
    [dispatch]
  );
  return (
    <Drawer
      title={t("Tipos de Tarefas")}
      placement="right"
      width={400}
      onClose={onClose}
      afterVisibleChange={(open) => {
        if (!open && typeof onAfterClose === "function") onAfterClose();
      }}
      open={visible}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose}>{t("Fechar")}</Button>
        </div>
      }
    >
      <List
        itemLayout="horizontal"
        dataSource={tipos}
        renderItem={(item) => (
          <List.Item
            onClick={() => handleAlterarClick(item.id)}
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #d9d9d9",
              padding: "12px 0",
            }}
          >
            <div
              style={{
                backgroundColor: `#${item.cor}`,
                color: "#fff",
                padding: "4px 8px",
                borderRadius: 4,
                display: "inline-block",
                width: "50%",
              }}
            >
              {item.nome}
            </div>
          </List.Item>
        )}
      />
    </Drawer>
  );
}

TiposTarefasDrawer.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onAfterClose: PropTypes.func,
};
